/**
 * @todo: эта штука во всех компонентах
 * которые не будут маппить геттеры из стора
 * будет ломаться, потому что миксин лезет в
 * this.метод  которого может и не быть
 *
 * перенес в геттер в сторе hasAccess
 * @DEPRECATED
 */
// eslint-disable-next-line import/prefer-default-export
export const access = {
  data() {
    return {
    };
  },
  methods: {
    // ignoreSwitch = true - don't check user privilege
    hasAccess(privilege, managerPrivilege = null, ignoreSwitch = false) {
      const preProdPrivilege = { resource: 'pre-prod', code: 'access' };
      try {
        if (!ignoreSwitch && !this.isSwitched) {
          return this.userAuthenticator(privilege);
        }
        return ((ignoreSwitch || this.userAuthenticator(privilege))
            && this.authAuthenticator(managerPrivilege))
          || (this.authAuthenticator(preProdPrivilege)
          && this.authAuthenticator(managerPrivilege));
      } catch (exception) {
        return false;
      }
    },
  },
};
